import React from 'react';
import InputTypes from '../../../common/components/InputTypes';

interface IProps {
    firstName: string;
    lastName: string;
    email: string;
    errors: {
        [key: string]: string;
    };
    handleChange(event: React.ChangeEvent<HTMLFormElement>): void;
    handleBlur(event: React.ChangeEvent<HTMLFormElement>): void;
};

const UserDetails: React.FC<IProps> = ({ firstName, lastName, email, handleChange, handleBlur, errors }) => (
    <div className="p-contributionForm">
        <fieldset className="c-form__fieldSet">
            <legend className="c-form__title box-title">Your details</legend>
            <div className="flex-column-s flex-row-top-justify-m flex-row-top-justify-l">
                <div className="p-fieldHalf">
                    <InputTypes
                        name="firstName"
                        label="First name"
                        value={firstName}
                        isRequired={true}
                        autocomplete="given-name"
                        error={errors.firstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                </div>
                <div className="p-fieldHalf">
                    <InputTypes
                        name="lastName"
                        label="Last name"
                        error={errors.lastName}
                        value={lastName}
                        isRequired={true}
                        autocomplete="family-name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                </div>
            </div>
            <InputTypes
                type="email"
                name="email"
                label="Email address"
                error={errors.email}
                value={email}
                isRequired={true}
                pattern="(@)(.+)$"
                errorMessage="Please enter a valid email address"
                autocomplete="email"
                onChange={handleChange}
                onBlur={handleBlur}
            />
        </fieldset>
    </div>
);

export default UserDetails;
